import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import "./styles/common.less"
// import './mock'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
const app = createApp(App)

app.use(store)
    .use(router)
    .use(ViewUIPlus)
    .use(Viewer)
    .mount('#app')